export default __webpack_public_path__ + "static/media/santa_title_mobile.73b8bc66.png";